import { mount } from 'svelte';
import NewsletterElement from '$js/components/organisms/newsletter/newsletter.svelte';

export class Newsletter {
    constructor() {
        const targets = document.querySelectorAll<HTMLElement>('.js-newsletter');

        if (!targets.length) {
            return;
        }

        targets.forEach((target) => {
            mount(NewsletterElement, {
                target,
                props: {
                    large: target.dataset.large === 'true',
                },
            });
        });
    }
}
